class CartDiscount extends HTMLElement {
    constructor() {
        super()
    }

    connectedCallback() {
        if(this.classList.contains("is-init")) return;
      
        this.applyBtn = this.querySelector("[js-discount-apply-btn]");
        this.discountField = this.querySelector("[js-discount-field]");
        this.discountErrorEl = this.querySelector("[js-discount-error]");
        this.removeDiscountBtn = this.querySelector("[js-remove-discount-btn]");
        this.accordionHeader = this.querySelector("[js-discount-accordion-header]");

        this.applyBtn.addEventListener("click", this.applyDiscount.bind(this));
        this.discountField.addEventListener("input", this.handleField.bind(this));
        this.removeDiscountBtn?.addEventListener("click", this.removeDiscount.bind(this));
        this.accordionHeader.addEventListener("click", this.handleAccordion.bind(this));

        this.classList.add("is-init");
    }
    
    async applyDiscount({ currentTarget }) {
        currentTarget.textContent = "Applying...";
        currentTarget.classList.add("is-loading");

        let sectionsToBundle = [];
        document.documentElement.dispatchEvent(new CustomEvent("cart:prepare-bundled-sections", { bubbles: true, detail: { sections: sectionsToBundle } }));

        const response = await fetch(`${window.Shopify.routes.root}cart/update.js`, {
          method: 'POST',
          body: JSON.stringify({
            discount:  `${this.discountField.value}`,
            sections: sectionsToBundle.join(",")
          }),
          headers: {
            "Content-Type": "application/json",
          },
        });
        const cartContent = await response.json();
        
        const { applicable } = cartContent.discount_codes[0];

        if(applicable) {
            document.documentElement.dispatchEvent(new CustomEvent("cart:change", {
                bubbles: true,
                detail: {
                baseEvent: "line-item:change",
                cart: cartContent
                }
            }));
        }else {
            this.discountErrorEl.classList.remove("hidden");
        }

        currentTarget.textContent = "Apply";
        currentTarget.classList.remove("is-loading");
    }

    async removeDiscount() {
        let sectionsToBundle = [];
        document.documentElement.dispatchEvent(new CustomEvent("cart:prepare-bundled-sections", { bubbles: true, detail: { sections: sectionsToBundle } }));

        const response = await fetch(`${window.Shopify.routes.root}cart/update.js`, {
          method: 'POST',
          body: JSON.stringify({
            discount:  ``,
            sections: sectionsToBundle.join(",")
          }),
          headers: {
            "Content-Type": "application/json",
          },
        });
        const cartContent = await response.json();
        document.documentElement.dispatchEvent(new CustomEvent("cart:change", {
            bubbles: true,
            detail: {
            baseEvent: "line-item:change",
            cart: cartContent
            }
        }));
    }

    handleField({ currentTarget }) {
        if(currentTarget.value) {
            this.applyBtn.classList.remove("is-disabled")
        }else {
            this.applyBtn.classList.add("is-disabled")
        }
    }

    handleAccordion({ currentTarget }) {
        const accordion = currentTarget.closest("[js-discount-accordion]");
        accordion.classList.toggle("is-open");
    }
}

customElements.define('cart-discount-component', CartDiscount);